import type { BottomSheetProps } from './BottomSheet';

export interface OldBottomSheetProps
  extends Omit<
    BottomSheetProps,
    'open' | 'description' | 'shouldCloseOnOutsideClick' | 'shouldCloseOnEscapeKey' | 'shouldCloseOnDrag'
  > {
  /** @deprecated open을 대신 사용해주세요. */
  opened?: boolean;
  /** @deprecated description을 대신 사용해주세요. */
  subTitle?: BottomSheetProps['description'];
  /** @deprecated shouldCloseOnOutsideClick을 대신 사용해주세요. */
  canClickOutside?: boolean;
  /** @deprecated shouldCloseOnEscapeKey를 대신 사용해주세요. */
  canCloseEscapeKey?: boolean;
  /** @deprecated shouldCloseOnDrag를 대신 사용해주세요. */
  canDragClose?: boolean;
}

export function convertOldBottomSheetProps(props: OldBottomSheetProps): BottomSheetProps {
  const { opened, subTitle, canClickOutside, canCloseEscapeKey, canDragClose, ...restProps } = props;

  return {
    ...restProps,
    open: opened,
    description: subTitle,
    shouldCloseOnOutsideClick: canClickOutside,
    shouldCloseOnEscapeKey: canCloseEscapeKey,
    shouldCloseOnDrag: canDragClose,
  };
}
